/**
 * Poll a live Tradier order's status every `intervalMs` for up to `maxMs`.
 * Stops early once status reaches a terminal state.
 */
import { orderStatus } from "./api";

const TERMINAL = new Set(["filled", "canceled", "cancelled", "rejected", "expired", "error"]);

export const pollOrderStatus = ({ orderId, onUpdate, intervalMs = 5000, maxMs = 120000 }) => {
  const start = Date.now();
  let stopped = false;
  const tick = async () => {
    if (stopped) return;
    try {
      const s = await orderStatus(orderId);
      onUpdate?.(s);
      if (TERMINAL.has(String(s.status || "").toLowerCase())) return;
    } catch (e) {
      // swallow; keep polling until timeout
    }
    if (Date.now() - start >= maxMs) return;
    setTimeout(tick, intervalMs);
  };
  // Fire the first tick after a short delay so the initial submit response paints
  setTimeout(tick, 1500);
  return () => { stopped = true; };
};

export const STATUS_COLORS = {
  filled: "#00E676",
  partially_filled: "#00E676",
  open: "#FFD60A",
  pending: "#FFD60A",
  submitted: "#FFD60A",
  accepted: "#FFD60A",
  canceled: "#71717A",
  cancelled: "#71717A",
  rejected: "#FF3B30",
  expired: "#71717A",
  error: "#FF3B30",
  unknown: "#71717A",
};

export const isOpenStatus = (s) => {
  const v = String(s || "").toLowerCase();
  return !TERMINAL.has(v) && v !== "";
};
